module.exports = __webpack_public_path__ + "static/media/property.8fa29ac5.svg";